import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';

import { Icon, UploadFile, useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';
import { type ModelType } from 'app/main/components/hooks/useModel';

export default function CompaniesDetailsSectionBusinessCard({
	uid,
	businessCard,
	isEdit,
	sendFilesChange
}: {
	uid: string;
	businessCard: { front: string; back: string };
	isEdit: boolean;
	sendFilesChange: ModelType['sendFilesChange'];
}) {
	const { t } = useSettings();

	const [side, setSide] = React.useState(businessCard.front ? 'front' : 'back');
	const file = businessCard[side];

	return (
		<DetailsSectionWrapper
			classes={{ content: 'justify-items-center' }}
			avatar={<Icon icon="smart-card-outline" />}
			title={t('DETAILS_COMPANIES_BUSINESS_CARD_SECTION')}
			subheader={t('DETAILS_COMPANIES_BUSINESS_CARD_SUBHEADER')}
			headerAction={
				businessCard.front && businessCard.back && !isEdit ? (
					<IconButton
						onClick={() => {
							setSide(side === 'front' ? 'back' : 'front');
						}}
					>
						<Icon icon="rotate-3d-variant" />
					</IconButton>
				) : undefined
			}
		>
			{!isEdit ? (
				file ? (
					<img
						className="max-h-256"
						src={`${import.meta.env.VITE_ENDPOINT}/resources/companies/${uid}/${file}?v=${Date.now()}`}
						alt={`business-card-${side}`}
					/>
				) : (
					<Typography textAlign="center">{t('BUSINESS_CARD_NO_IMAGE')}</Typography>
				)
			) : (
				<Grid container spacing={2}>
					<Grid size={12}>
						<UploadFile
							fieldName="comp_business_card_front"
							fileName="comp_business_card_front"
							path={`companies\\${uid}`}
							label={t('BUSINESS_CARD_FRONT')}
							value={businessCard.front}
							sendChange={sendFilesChange}
						/>
					</Grid>
					<Grid size={12}>
						<UploadFile
							fieldName="comp_business_card_back"
							fileName="comp_business_card_back"
							path={`companies\\${uid}`}
							label={t('BUSINESS_CARD_BACK')}
							value={businessCard.back}
							sendChange={sendFilesChange}
						/>
					</Grid>
				</Grid>
			)}
		</DetailsSectionWrapper>
	);
}
